// extracted by mini-css-extract-plugin
export default {"container":"XM-z","modal":"YM-z","dimensions":"ZM-z","brandName":"_M-z","productName":"aN-z","labelValue":"bN-z","recipientEmail":"cN-z","recommendedFit":"dN-z","hiddenField":"eN-z"};